import { onMounted, onUpdated, ref } from 'vue'

const useListId = (el) => {
  const itemListId = ref(null)

  const updateItemListId = async () => {
    if (typeof el.value?.closest !== 'function') return

    const { HTML_CUSTOM_ATTRIBUTES } = await import(
      '@/constants/GlobalConstants'
    )
    const listElement = el.value?.closest(
      '[' + HTML_CUSTOM_ATTRIBUTES.ITEM_LIST_ID + ']'
    )
    itemListId.value = listElement?.getAttribute('item-list-id')
  }
  onMounted(updateItemListId)
  onUpdated(updateItemListId)

  return { itemListId }
}

export { useListId }
